import { FC } from "react";
import { useTranslation } from "react-i18next";

import styles from "./UnsavedChangesModal.module.scss";
import { ConfirmModal } from "src/features";

interface Props {
  onAccept?: () => void;
  onCancel?: () => void;
}

export const UnsavedChangesModal: FC<Props> = ({ onAccept, onCancel }) => {
  const { t } = useTranslation();

  return (
    <ConfirmModal
      id="unsaved-changes"
      type="warning"
      acceptButton={{
        text: t("component.modal.unsaved_changes.button.submit"),
        buttonType: "error",
        onClick: onAccept,
      }}
      cancelButton={{
        text: t("component.modal.unsaved_changes.button.cancel"),
        onClick: onCancel,
      }} 
      title={t("component.modal.unsaved_changes.title")}
    >
      <div className={styles.wrapper}>
        <span>{t("component.modal.unsaved_changes.body")}</span>
      </div>
    </ConfirmModal>
  );
};
